module.exports = __webpack_public_path__ + "images/emoji/six_pointed_star.4ac3533b3245a2abf8e7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/six_pointed_star.png
// module id = fkug
// module chunks = 2